export default __webpack_public_path__ + "static/media/less-icon.30e63239.svg";